import moment from 'moment'

export default function (value, na='n/a') {
  return value && value !== '' ? moment(value).format('M/D/YYYY hh:mm a') : na
}
